import React from 'react';
import PropTypes from 'prop-types';
import FieldsList from './components/FieldsList';

import { FieldsProvider } from './FieldsContext';
import { FieldEditProvider } from './FieldEditContext';
import { FormLayoutProvider } from './FormLayoutContext';

const PageFieldsForm = () => {
  return (
    <FieldsProvider>
      <FormLayoutProvider>
        <FieldEditProvider>
          <FieldsList />
        </FieldEditProvider>
      </FormLayoutProvider>
    </FieldsProvider>
  );
};

PageFieldsForm.propTypes = {
  page: PropTypes.object.isRequired,
};

export default PageFieldsForm;
